
/** 默认头像 */
export const DEFAULT_AVATAR = 'https://file.40017.cn/huochepiao/activity/20200521supplies/img/defaultImg-fs8.png'
/** 默认昵称 */
export const DEFAULT_NICK = '同程用户'